/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_Left_NameInputs */

const cs_builder_prop_left_name = /** @type {(inputs: Builder_Prop_Left_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Levé jméno`)
};

const en_builder_prop_left_name = /** @type {(inputs: Builder_Prop_Left_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left name field`)
};

/**
* | output |
* | --- |
* | "Left name field" |
*
* @param {Builder_Prop_Left_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_left_name = /** @type {((inputs?: Builder_Prop_Left_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_Left_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_left_name(inputs)
	return cs_builder_prop_left_name(inputs)
});